'use client'

import { Dialog } from '@vinted/web-ui'

import Slides from './Slides'

const MODAL_CONTENT_DIMENSIONS = {
  height: 'calc(100% - 80px)',
  maxHeight: '812px',
}

type PhishingFirstTimeListerEducationProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

const PhishingFirstTimeListerEducation = ({
  isOpen,
  setIsOpen,
}: PhishingFirstTimeListerEducationProps) => {
  return (
    <Dialog
      show={isOpen}
      contentDimensions={MODAL_CONTENT_DIMENSIONS}
      testId="phishing-first-time-lister-education-modal"
    >
      <Slides setIsDialogOpen={setIsOpen} />
    </Dialog>
  )
}

export default PhishingFirstTimeListerEducation
